<template>
    <div class="or-product-card flex-row anim-scale hover-pointer">
        <img class="image" :src="options.image"/>
        <div class="content flex-column column-space-between">
            <p class="name">{{options.name}}</p>
            <p class="description">{{options.description}}</p>
            <p class="button anim-news-card">Подробнее</p>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        options: Object,
    },
}
</script>

<style scoped>
    .or-product-card {
        width: 1200px;
        height: 180px;
        background-color: #1e1e1e;
        padding: 20px;
        box-sizing: border-box;
        border-radius: 8px;
    }
    .image {
        width: 136px;
        height: 139px;
        object-fit: cover;
        object-position: center;
        margin-right: 56px;
        border-radius: 8px;
    }
    .content {
        text-align: left;
    }
    .name {
        font-size: 20px;
        line-height: 23px;
        color: #EBB932;
    }
    .description {
        font-size: 14px;
        line-height: 24px;
        color: #ffffff;
    }
    .button {
        font-size: 14px;
        line-height: 14px;
        color: #EBB932;
    }
</style>